import * as Sentry from '@sentry/react-native';
import getConfig from '../utils/getConfig';
import {isProd} from '../utils/isDev';

const SENTRY_DSN =
  'https://f03950abe638ab50f5bc25a480be7e56@o332124.ingest.sentry.io/4506335978389504';

let initialized = false;

const getReleaseName = () =>
  `${getConfig('BUNDLE_ID')}@${getConfig('APP_VERSION')}`;

export const initializeSentry = () => {
  if (initialized) {
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    enabled: isProd(),
    release: getReleaseName(),
    environment: getConfig('MY_WORKS_ENVIRONMENT'),
  });

  initialized = true;
};

export const setSentryUserContext = (user?: {
  id?: string;
  email?: string;
  username?: string;
} | null) => {
  if (user?.id) {
    Sentry.setUser({
      id: user.id,
      email: user.email,
      username: user.username,
    });
    return;
  }

  Sentry.setUser(null);
};

export const setSentryUnitContext = (unitId?: string | null) => {
  Sentry.setTag('unit.id', unitId || 'none');
  Sentry.setContext('unit', {
    id: unitId || 'none',
  });
};

export const setSentryRouteContext = (routeName?: string | null) => {
  Sentry.setTag('route', routeName || 'unknown');
};

export const clearSentryContext = () => {
  Sentry.setUser(null);
  Sentry.setTag('unit.id', 'none');
  Sentry.setTag('route', 'unknown');
  Sentry.setContext('unit', {
    id: 'none',
  });
};
